import React, { useEffect } from "react";
import { useGetCompanyDetails } from "../../../hooks/api/useGetCompanyDetails";
import { useReportError } from "../../../hooks/useReportError";

/**
 * Fetches company details once so `currencyCode` is available for `useFormatCurrency`.
 * Renders children only — no UI.
 */
const CompanyCurrencyBootstrap: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const { mutateAsync } = useGetCompanyDetails();
  const reportError = useReportError();

  useEffect(() => {
    void mutateAsync().catch((err: unknown) => {
      reportError("Failed to load company details (currency)", err, {
        component: "CompanyCurrencyBootstrap"
      });
    });
  }, [mutateAsync, reportError]);

  return <>{children}</>;
};

export default CompanyCurrencyBootstrap;
